/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BrandListQuery,
    BrandListQueryFromJSON,
    BrandListQueryToJSON,
    BrandListResponse,
    BrandListResponseFromJSON,
    BrandListResponseToJSON,
} from '../models';

export interface ApiBrandListDataPostRequest {
    brandListQuery?: BrandListQuery;
}

/**
 * no description
 */
export class BrandListApi extends runtime.BaseAPI {

    /**
     */
    async apiBrandListDataPostRaw(requestParameters: ApiBrandListDataPostRequest): Promise<runtime.ApiResponse<BrandListResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BrandList/Data`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BrandListQueryToJSON(requestParameters.brandListQuery),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => BrandListResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiBrandListDataPost(requestParameters: ApiBrandListDataPostRequest): Promise<BrandListResponse> {
        const response = await this.apiBrandListDataPostRaw(requestParameters);
        return await response.value();
    }

}
